import * as actionTypes from 'modules/Profile/redux/relations/actionTypes';

export const getRelations = (payload) => ({ type: actionTypes.GET_RELATIONS, payload });
export const getRelationsSuccess = (payload) => ({
  type: actionTypes.GET_RELATIONS_SUCCESS,
  payload,
});
export const getRelationsError = (payload) => ({
  type: actionTypes.GET_RELATIONS_FAILURE,
  payload,
});

export const updateRelation = (type, data) => ({
  type: actionTypes.UPDATE_RELATIONS,
  payload: { type, data },
});

export const updateRelationSuccess = (type, data) => ({
  type: actionTypes.UPDATE_RELATIONS_SUCCESS,
  payload: { type, data },
});

export const updateRelationError = (type, data) => ({
  type: actionTypes.UPDATE_RELATIONS_FAILURE,
  payload: { type, data },
});

export const getActiveRelations = (payload) => ({
  type: actionTypes.GET_ACTIVE,
  payload,
});

export const getActiveRelationsSuccess = (payload) => ({
  type: actionTypes.GET_ACTIVE_SUCCESS,
  payload,
});

export const getActiveRelationsError = (payload) => ({
  type: actionTypes.GET_ACTIVE_FAILURE,
  payload,
});
